import { useMutation, useQueryClient } from '@tanstack/react-query';
import campaignService from 'v2/services/campaigns';

interface UpdatePostbackParams {
  productId: number;
  script: string;
  destiny: string;
  type: string;
}

export function useUpdatePostback() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ productId, script, destiny, type }: UpdatePostbackParams) =>
      campaignService.updatePostback(productId, script, destiny, type),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['postback', variables.productId] });
    }
  });
}
